import NotificationItem from './NotificationItem';

export default NotificationItem;
